
/**
 * @deprecated A gestão de permissões de projeto foi unificada em
 * /settings?tab=access (Acessos & Permissões → contexto Projeto).
 */
export default function ProjectPermissionsRedirect() {
    return null;
}

